import { styled } from '@mui/material/styles';
import { PreviewCard } from '@aibees/elephant/components/backoffice/preview-card';

export const Wrapper = styled(PreviewCard)``;
